module.exports = "https://cdn.hellotech.com/client-assets/suddenlinkLogo_27178dcd0bf4dc728f96a319a3add038.svg";